import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "@/services/firebase";
import APP_CONFIG from "../../../app.config"; // Assurez-vous que le chemin est correct

const buildDisplayNameParts = () => {
  const rawDisplayName = auth.currentUser?.displayName || "";
  const fullName = rawDisplayName.trim();

  if (!fullName) {
    return {
      firstName: null,
      lastName: null,
      fullName: null,
    };
  }

  const [firstName, ...lastNameParts] = fullName.split(/\s+/);
  return {
    firstName: firstName || null,
    lastName: lastNameParts.join(" ") || null,
    fullName,
  };
};

/**
 * Crée le document utilisateur s'il n'existe pas encore.
 * @param {string} uid - L'identifiant Firebase Auth
 * @param {string} email - L'adresse e-mail de l'utilisateur
 */
const createUserIfNotExists = async (uid, email) => {
  const userRef = doc(db, "users", uid);
  const snapshot = await getDoc(userRef);

  if (!snapshot.exists()) {
    const { firstName, lastName, fullName } = buildDisplayNameParts();

    await setDoc(userRef, {
      role: APP_CONFIG.defaultUserRole,
      firstName,
      lastName,
      fullName,
      active: true,
      actif: true,
      archived: false,
      deleted: false,
      email: email || null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    console.log("🆕 Document utilisateur créé dans Firestore");
  } else {
    console.log("ℹ️ Document utilisateur déjà existant");
  }
};

export default createUserIfNotExists;
